export default __webpack_public_path__ + "static/media/splash-logo-new.fb761374.png";